import Vue from "vue";
import Router from "vue-router";

// 登录页
const Login = () => import("./components/login/login");
// 布局页面
const tabbar = () => import("./components/common/tabbar");
// 点位管理
const mediaList = () => import("./components/media/mediaList");
const mediaDetail = () => import("./components/media/mediaDetail");
// 预播列表
const readyPlayList = () => import("./components/media/readyPlayList");
//广告包管理
const adPackage = () => import("./components/ADPackage/adPackage");
// 投放管理
const channelAdPlan = () => import("./components/channelAd/channelAdPlan");
const channelAdPlanDetail = () =>
  import("./components/channelAd/channelAdPlanDetail");
const createAdPlan = () => import("./components/channelAd/createAdPlan");
const channelPlanSet = () => import("./components/channelAd/channelAdPlanSet");
const channelTargetSet = () =>
  import("./components/channelAd/channelTargetSet");
const channelMaterialSet = () =>
  import("./components/channelAd/channelMaterialSet");
//客户管理
const clientList = () => import("./components/client/clientList");
const clientDetail = () => import("./components/client/clientDetail");
const createClient = () => import("./components/client/createClient");

// 标签管理
const tags = () => import("./components/tagsManagement/tags");

// qadm 没有主页。登陆之后直接跳转到广告计划。没有广告计划权限，
// 跳转到对于权限页面。
// 以后可能会添加。
const index = () => import("./components/index/index");

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // 登陆页面
    {
      path: "/",
      redirect: {
        name: "login"
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    //内容页面
    {
      path: "/",
      component: tabbar,
      children: [
        // 首页
        {
          path: "/index",
          name: "index",
          component: index
        },
        // 投放管理
        {
          path: "/channelAdPlan",
          name: "channelAdPlan",
          component: channelAdPlan
        },
        {
          path: "/channelAdPlanDetail",
          name: "channelAdPlanDetail",
          component: channelAdPlanDetail
        },
        {
          path: "/channelPlanSet",
          component: createAdPlan,
          children: [
            {
              path: "",
              name: "channelPlanSet",
              component: channelPlanSet
            },
            {
              path: "/channelTargetSet",
              name: "channelTargetSet",
              component: channelTargetSet
            },
            {
              path: "/channelMaterialSet",
              name: "channelMaterialSet",
              component: channelMaterialSet
            }
          ]
        },
        //点位管理
        {
          path: "/mediaList",
          name: "mediaList",
          component: mediaList
        },
        {
          path: "/mediaDetail",
          name: "mediaDetail",
          component: mediaDetail
        },
        // 预播列表
        {
          path: "/readyPlayList",
          name: "readyPlayList",
          component: readyPlayList
        },
        //广告包管理
        {
          path: "/adPackage",
          name: "adPackage",
          component: adPackage
        },
        //客户管理
        {
          path: "/clientList",
          name: "clientList",
          component: clientList
        },
        {
          path: "/clientDetail",
          name: "clientDetail",
          component: clientDetail
        },
        {
          path: "/createClient",
          name: "createClient",
          component: createClient
        },
        // 标签管理
        {
          path: "/tags",
          name: "tags",
          component: tags
        }
      ]
    },
    {
      path: "*",
      redirect: {
        name: "login"
      }
    }
  ]
});
